import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";
import { normGroups } from "@/lib/acl";
import { useCurrentUser } from "@/lib/auth";
import { useBestellwesenNavigationWithUser } from "@/lib/bestellwesenNav";
import { useMemo } from "react";

/** Leitet Büro-Nutzer mit Hub-Zugriff auf /bestellwesen/… um; sonst Standalone-Seite. */
export function BestellwesenLegacyRedirect({
  hubSegment,
  children,
}: {
  hubSegment: string;
  children: ReactNode;
}) {
  const { user } = useCurrentUser();
  const groups = useMemo(() => normGroups((user?.groups as string[] | undefined) ?? []), [user]);
  const location = useLocation();
  const { showSidebar, loading } = useBestellwesenNavigationWithUser(groups);

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  if (showSidebar) {
    const base = `/${hubSegment}`;
    const path = location.pathname.replace(/\/$/, "") || "";
    const suffix =
      path === base || path.startsWith(`${base}/`) ? path.slice(base.length) : "";
    return (
      <Navigate
        to={`/bestellwesen/${hubSegment}${suffix}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
